import { useState } from "react";
import { useSelector } from "react-redux";
import today from "../../../Artifacts/Todaysretail.png";
import Percentage from "../../../Artifacts/percentage.png";
import { PriKPI } from "../../../Components/KPI/PriKPI";
import { useQuery } from "@tanstack/react-query";
import { TbFilterDown } from "react-icons/tb";
import PipelineFilter from "../../../Components/Filters/PipelineFilter.jsx";

import { pipeline_kpi } from "./ApiPipeLine.js";

export const PipeLineKpi = () => {
  const { data, submitted } = useSelector((state) => state.filtersPipeline);
  const [isFormVisible, setFormVisible] = useState(false);

  const { data: kpiData } = useQuery({
    queryKey: ["pipeline_kpi", submitted],
    queryFn: () => pipeline_kpi(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });
  const conversionC0C3 =
    kpiData?.conversion_c0_c3 !== undefined
      ? Math.round(kpiData.conversion_c0_c3 * 100) + "%"
      : "0";

  const conversionC1AC3 =
    kpiData?.conversion_c1a_c3 !== undefined
      ? Math.round(kpiData.conversion_c1a_c3 * 100) + "%"
      : "0";

  const toggleForm = () => {
    setFormVisible(!isFormVisible);
  };

  return (
    <div className="flex flex-col gap-2 ">
      {isFormVisible && (
        <PipelineFilter
          isFormVisible={isFormVisible}
          setFormVisible={setFormVisible}
        />
      )}
      <div className="flex gap-2  md:flex-row flex-col-reverse">
        <section className="md:grid block grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4 md:w-[95%] w-full">
          <PriKPI
            Image={today}
            Alt={"TAT C0 to C3"}
            ColorDark={"bg-gradient-to-b from-[#3CD0C0] to-[#129BD2]"}
            Title={"TAT C0 to C3"}
            Value={kpiData?.tat_c0_c3 || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
            ImageSize={"w-14 h-14"}
          />

          <PriKPI
            Image={Percentage}
            Alt={"Conversion % C0 to C3(within 3 days)"}
            ColorDark={"bg-gradient-to-b from-[#FFE700] to-[#F9A526]"}
            Title={"Conversion % C0 to C3 "}
            subtext={"Within 3 days"}
            Value={conversionC0C3 || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
          />

          <PriKPI
            Image={today}
            Alt={"TAT C1A to C3"}
            ColorDark={"bg-gradient-to-t from-sky-500 to-sky-300"}
            Title={"TAT C1A to C3"}
            Value={kpiData?.tat_c1a_c3 || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
            ImageSize={"w-14 h-14"}
          />
          <PriKPI
            Image={Percentage}
            Alt={"Conversion % C1A to C3"}
            ColorDark={"bg-gradient-to-b from-[#EF6AE9] to-[#8463FA]"}
            Title={"Conversion % C1A to C3"}
            subtext={"Within 3 days"}
            Value={conversionC1AC3 || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
          />
        </section>
        <div
          className="w-full lg:w-[5%] rounded-lg p-2 bg-gradient-to-b from-rose-300 to-orange-200 flex justify-center items-center transition duration-300 ease-in-out transform hover:scale-105 cursor-pointer "
          onClick={toggleForm}
        >
          <button title="Click to Apply Filters">
            <TbFilterDown className="w-7 h-7 text-[#2A5775]" />
          </button>
        </div>
      </div>
    </div>
  );
};
